module.exports = __webpack_public_path__ + "img/51.5f172b43.png";